var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43359 3.5V5.5M6.43359 7.5H6.43859M11.4336 5.5C11.4336 8.26142 9.19502 10.5 6.43359 10.5C3.67217 10.5 1.43359 8.26142 1.43359 5.5C1.43359 2.73858 3.67217 0.5 6.43359 0.5C9.19502 0.5 11.4336 2.73858 11.4336 5.5Z",
    stroke: "#8C8F93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyInfo);
export default __webpack_public_path__ + "static/media/grey-info.568ad1b79a2c8759586c6230d00fc756.svg";
export { ForwardRef as ReactComponent };